module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.63326434.ttf";